<template>
  <div class="quick-replies">
    <div
      v-for="(action, index) in actions"
      :key="index"
      :style="getStyle()"
      @click="sendQuickReply(action)"
      class="reply"
    >
      <div class="reply-title">{{ action }}</div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { PropType } from 'vue';

const props = defineProps({
  messageColour: {
    type: String,
    required: true,
  },
  actions: {
    type: Array as PropType<string[]>,
    required: true,
  },
});

const emit = defineEmits<{
  (e: 'sendQuickReply', payload: any): void;
}>();

function getStyle() {
  return {
    border: `1px solid ${props.messageColour}`,
    color: props.messageColour,
  };
}

function sendQuickReply(reply: string): void {
  emit('sendQuickReply', {
    text: reply,
    isQuickReplyResponse: true,
  });
}
</script>

<style scoped lang="scss">
.quick-replies {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  margin-left: 1.5em;

  .reply {
    padding: 0.5em 1em;
    border-radius: 5em;
    cursor: pointer;
    margin: 0.25em;
    transition: 200ms;

    &:hover {
      box-shadow: 0 1px 8px 1px rgba(0, 0, 0, 0.2);
    }
  }
}
</style>
